import { ModifyContextState, ToastContext, ToastContextProvider } from 'context/toastContext';
import React, { useState } from 'react';
import { Row, Toast } from 'react-bootstrap';

import { useSelector } from 'react-redux';
import uuid from 'uuid';

const SpawnToast = (props) => {
  const message = typeof props.message === 'object' ? '' : props.message;
  return (
    <Toast
      onClose={() => {
        ModifyContextState.removeToastMessage(message);
      }}
      show={props.show}
      delay={3000}
      autohide
    >
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  );
};

const Toasts = () => {
  const [show, setShow] = useState(true);
  const modalState = false;
  const userLoggedIn = useSelector((state) => state.user.loggedIn);
  if (userLoggedIn === false) {
    return null;
  }
  return (
    <ToastContextProvider>
      <Row className={modalState === true ? `toast-container overlap` : `toast-container hidden`}>
        <ToastContext.Consumer>
          {(value) => {
            return value.messages.map((item) => {
              return <SpawnToast key={uuid.v4()} show={show} setShow={setShow} message={item} />;
            });
          }}
        </ToastContext.Consumer>
      </Row>
    </ToastContextProvider>
  );
};

export { Toasts };
